import { IoClose } from "react-icons/io5";
import "../../pages/Notification/KeyWordManage.css"

export default function KeywordSection({ 
  title, 
  category, 
  inputValue, 
  keywordList, 
  onChange, 
  onAdd, 
  onKeyDown, 
  onDelete 
}) {
  return (
    <div className="notification-detail">
      <h2>{title}</h2>
      <div className="keyword-input-section">
        <input className="keyword-input"
        value={inputValue} 
        placeholder="키워드 추가..." 
        onChange={(e) => onChange(category, e)} 
        onKeyDown={(e) => onKeyDown(category, e)} 
        />
        <button className="keyword-input-btn" onClick={() => onAdd(category)}>추가</button>
      </div>
      
      <div className="keyword-list">
        {keywordList.map((keyword) => (
          <div className="keyword" key={keyword}>
            {keyword}
            <IoClose 
              className="ioclose"
              onClick={() => onDelete(category, keyword)}
            />
          </div>
        ))}
      </div>
      <hr />
    </div>
  );
}